import { Atom } from 'AppReact';
import styled from "styled-components";

const template = styled.div`
`;


export default Atom({ type: 'label', dataType: 'object', template })